import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-otp-generate',
  template: `
  <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{length:4,disableAutoFocus:disableAutoFocus}"></ng-otp-input>
  `,
  styleUrls: ['./otp-generate.component.less']
})
export class OtpGenerateComponent extends FieldType {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;//Get reference using ViewChild and the specified hash
  formControl!: FormControl;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  onOtpChange($event: any) {
    this.model[this.key + ''] = $event;
    if (this.to.onOtpChange) {
      this.to.onOtpChange($event);
    }
  }
  get disableAutoFocus() { return !!this.to.disableAutoFocus }
}
